import { blogPathPlaceholder } from 'publisher/reducers/blogReducer'

export const resolveSearchBasePath = (path?: null | string) => {
  if (!path || path === blogPathPlaceholder) {
    return ''
  }

  return path.endsWith('/') ? path.slice(0, -1) : path
}
